import ReactDOM from 'react-dom/client'
import { Router } from './components/Router.jsx'
import './styles'

document.getElementById('loader').style.display = 'none'

ReactDOM.createRoot(document.getElementById('root')).render(
  <Router/>
)
